var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon icon-document-container",style:(`background: ${_vm.$options.colors[_vm.documentType] || 'black'}`)},[_c('icon-document',{staticClass:"has-text-light",attrs:{"document-type":_vm.documentType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }